import { render, staticRenderFns } from "./DetailCandidate.vue?vue&type=template&id=275c7328&scoped=true"
import script from "./DetailCandidate.vue?vue&type=script&lang=js"
export * from "./DetailCandidate.vue?vue&type=script&lang=js"
import style0 from "./DetailCandidate.vue?vue&type=style&index=0&id=275c7328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c7328",
  null
  
)

export default component.exports